import { gql } from '@apollo/client';

export const ALL_FILTERED_INSTITUTIONS = gql`
  query AllFilteredInstitutions($input: FilterInstitutions!) {
    institutions: filteredInstitutions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          emisNumber
          schoolEmmisNumber
          cohorts {
            id
            name
            isInstitutionCohort
            isInterventionCohort
            isPeopleCohort
          }
          district {
            id
            name
          }
          ministry {
            id
            name
          }
          type {
            id
            name
          }
          streetAddress
          stakeholdersCount
          districtMunicipality {
            id
            name
          }
        }
      }
    }
  }
`;
